<template>
  <Starfield>
    <GrantsList :grants="grants" />
  </Starfield>
</template>

<script>
import Starfield from "@/components/Starfield";
import GrantsList from "@/components/GrantsList";

export default {
  name: "GrantsSettings",
  components: { Starfield, GrantsList },
  props: {
    grants: { type: Array, default: () => [] },
  },
};
</script>
